export const EMOTARS = "emotars";
export const USER_MENU = "userMenu";
export type UserMenuSection = typeof EMOTARS | typeof USER_MENU;
